var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.5","d":"M9 3 3 9m0-6 6 6"}})])
}
var staticRenderFns = []

export default { render: render }